<template>
  <div class="">
    <loading :loading="loading" />
    <md-table v-if="!loading">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Sensor Virtual</h1>
        </div>
        <div class="md-toolbar-section-end">
          <md-button class="md-primary md-raised" @click="pushCreate">
            Criar Sensor Virtual
          </md-button>
          <md-field style="width: 50%">
            <md-input v-model="search" placeholder="Buscar sensor" />
          </md-field>
          <md-button
            class="md-primary md-raised"
            @click="searchSensoresVirtuais"
          >
            Buscar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Titulo</md-table-head>
        <md-table-head>Sensor</md-table-head>
        <md-table-head>Criado em</md-table-head>
        <md-table-head>Ação</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="virtual in sensoresVirtual"
        :key="virtual.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ virtual.titulo }}</md-table-cell>
        <md-table-cell>{{ virtual.sensorIndentificador }}</md-table-cell>
        <md-table-cell>
          {{
            new Date(virtual.criadoEm)
              .utcToLocalDate()
              .toLocaleDateString('pt-BR')
          }}
        </md-table-cell>
        <md-table-cell>
          <md-button
            class="md-raised md-primary"
            @click="() => pushEditar(virtual.id)"
          >
            Editar
          </md-button>
          <md-button
            class="md-raised md-accent"
            @click="() => (deleteObj = { ...virtual })"
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="showDialogDelete"
      md-title="Tem certeza?"
      md-content="Deseja realmente remover o sensor virtual?"
      md-confirm-text="remover"
      md-cancel-text="cancelar"
      @md-confirm="() => removeSensorVirtual()"
      @md-cancel="() => (deleteObj = null)"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'

import http from '../../utils/http'

export default {
  name: 'SensorVirtualIndex',
  components: { Loading },
  data() {
    return {
      loading: true,
      localId: null,
      sensorId: null,
      deleteObj: null,
      sensoresVirtual: [],
      search: '',
    }
  },
  computed: {
    showDialogDelete() {
      return this.deleteObj !== null
    },
  },
  async beforeMount() {
    this.localId = this.$route.params.localId
    this.sensorId = this.$route.params.sensorId

    await this.searchSensoresVirtuais()
  },
  methods: {
    async searchSensoresVirtuais() {
      this.loading = true

      const response = await http.get(`local/${this.localId}/sensor/virtual`, {
        s: this.search,
        sensorId: this.sensorId,
      })

      this.sensoresVirtual = response.sensoresVirtual

      this.loading = false
    },
    async removeSensorVirtual() {
      await http.delete(
        `sensor/${this.deleteObj.sensorId}/virtual`,
        this.deleteObj.id
      )

      await this.searchSensoresVirtuais()

      this.deleteObj = null
    },
    pushCreate() {
      this.$router.push({ name: 'SensorVirtualCreate' })
    },
    pushEditar(id) {
      this.$router.push({
        name: 'SensorVirtualEdit',
        params: {
          localId: this.localId,
          sensorVirtualId: id,
        },
      })
    },
  },
}
</script>
